import gql from 'graphql-tag';

/**
 * Fetches the `isBookedBlock` transition history (provider side) for a single
 * DayAvailability, newest first. Backs the block-availability audit modal.
 */
export const GET_PROVIDER_ISBOOKED_AUDIT_HISTORY = gql`
  query($availabilityId: Int!) {
    getProviderIsBookedAuditHistory(availabilityId: $availabilityId) {
      id
      availabilityId
      providerTemplateId
      providerId
      providerName
      dayOfWeek
      startTime
      endTime
      opensOn
      previousOpensOn
      previousValue
      newValue
      action
      actionBy
      eventId
      correlationId
      changedAt
    }
  }
`;

/**
 * Client-side equivalent of the provider isBookedBlock audit history.
 */
export const GET_CLIENT_ISBOOKED_AUDIT_HISTORY = gql`
  query($availabilityId: Int!) {
    getClientIsBookedAuditHistory(availabilityId: $availabilityId) {
      id
      availabilityId
      clientId
      clientName
      dayOfWeek
      startTime
      endTime
      opensOn
      previousOpensOn
      hasNonBTBooking
      previousHasNonBTBooking
      previousValue
      newValue
      action
      actionBy
      eventId
      correlationId
      changedAt
    }
  }
`;
